import { Component } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as authentication from '../../../actions/authentication.actions';

import PricingPlanTableSubscribeOption from '../PricingPlanTableSubscribeOption';
import withComponentName from '../../../decorators/withComponentName';
import withPriceCurrency from '../PriceCurrencyProvider/withPriceCurrency';

import { BASIC_PLAN, GUEST_PLAN } from '../../../data/subscriptionPlans';

import Styles from './planItemTableSubscribe.module.scss';

const cx = classNames.bind(Styles);

class PlanItemTableSubscribe extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  openSignModal() {
    const { actions } = this.props;
    actions.setAuthModalOpened(true);
  }

  handleSubscriptionClick() {
    const { activePlane, activePlaneType, planPriceInfo, onSubscribe } = this.props;
    const foundPlan = planPriceInfo
      .find((f) => f.plan_type === activePlaneType && f.plan_key === activePlane);
    onSubscribe(foundPlan);
  }

  render() {
    const {
      text,
      plan = false,
      basic = false,
      silver = false,
      gold = false,
      userPlan,
      current_plan,
      planPriceInfo,
      isUserWithPlan,
      activePlane,
      activePlaneType,
      isAddOnActive,
      addOnType,
      updateParentState,
      onSubscribe,
      hasInsightsAccess,
      currencyCode,
      currencySymbol,
      currency,
    } = this.props;

    const pricingPlansInner = cx('pricing_plan_inner', {
      guest: userPlan === GUEST_PLAN,
      'registered-user-plan': isUserWithPlan,
      'user-gold-plan': userPlan === 'gold_plan' && gold,
      'user-silver-plan': userPlan === 'silver_plan' && silver,
      'user-basic-plan': userPlan === 'basic_plan' && basic,
      gold,
      basic,
      silver,
      'user-title': plan,
      active: activePlane === current_plan,
    });

    const foundActivePlan = (planPriceInfo || [])
      .find((f) => f.plan_type === activePlaneType && f.plan_key === activePlane);
    let totalMainPrice = 0;
    let totalSubPrice = 0;
    let totalSubText = '';
    if (foundActivePlan) {
      const valueSuffix = currency === 'gbp' ? '_gbp' : '';
      totalMainPrice = foundActivePlan[`price${valueSuffix}`] + (isAddOnActive ? foundActivePlan[`add_on_${addOnType}${valueSuffix}`] : 0);
      totalSubPrice = (foundActivePlan[`total${valueSuffix}`] || 0) + (isAddOnActive ? foundActivePlan[`total_${addOnType}${valueSuffix}`] : 0);
      totalSubText = foundActivePlan.total_sub_text;
    }

    return (
      <div className={pricingPlansInner}>
        <div className={Styles['plan-body']}>
          <div className={cx('prices', { 'basic-plan': basic })}>
            {plan ? (<div className={Styles.prices_title}>Pricing</div>) : ''}
            {Array.isArray(planPriceInfo) && planPriceInfo.map((priceInfo) => (
              <PricingPlanTableSubscribeOption
                priceInfo={priceInfo}
                key={priceInfo.id}
                isUserWithPlan={isUserWithPlan}
                text={text}
                currentPlan={current_plan}
                gold={gold}
                silver={silver}
                onSubscribe={onSubscribe}
                basic={basic}
                userPlan={userPlan}
                activePlane={activePlane}
                activePlaneType={activePlaneType}
                isAddOnActive={isAddOnActive}
                addOnType={addOnType}
                updateParentState={updateParentState}
                hasInsightsAccess={hasInsightsAccess}
              />
            ))}
            {activePlane === current_plan && current_plan === BASIC_PLAN && (
              <div className={Styles['price-option-holder']}>
                <SubscribeButton
                  onSubscribe={this.handleSubscriptionClick}
                  silver={silver}
                />
                <div className={Styles['price-option-text']}>
                  <div className={Styles['price-option-text-main']}>
                    {currencySymbol}
                    0&nbps;
                    {currencyCode}
                    /month
                  </div>
                </div>
              </div>
            )}
          </div>
          {activePlane === current_plan && current_plan !== BASIC_PLAN && (
            <div className={Styles['price-option-holder']}>
              <SubscribeButton
                onSubscribe={this.handleSubscriptionClick}
                silver={silver}
              />
              <div className={Styles['price-option-text']}>
                <div className={Styles['price-option-text-main']}>
                  {currencySymbol}
                  {totalMainPrice}
                  {' '}
                  {currencyCode}
                  /month
                </div>
                {totalSubText && (
                  <div className={Styles['price-option-text-sub']}>
                    {!!totalSubPrice && (
                      <>
                        {currencySymbol}
                        {totalSubPrice}
                        {' '}
                      </>
                    )}
                    {totalSubText}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const SubscribeButton = ({
  silver, onSubscribe, longTermBtnOption,
}) => {
  const btnText = silver
    ? 'Start Free Trial'
    : 'Subscribe';
  return (
    <button
      type="button"
      onClick={onSubscribe}
      className={cx('price-option-btn', { 'long-term-option': longTermBtnOption })}
    >
      {btnText}
    </button>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    ...authentication,
  }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withComponentName(
    withPriceCurrency(PlanItemTableSubscribe),
  ),
);
